import React from 'react';
import { useIntl } from 'react-intl';
import { formatListValue } from '@/shared/components/FormattedListValue';
import messages from './FieldMessages';

const AddressSettingChange = props => {
  const intl = useIntl();
  const { log } = props;

  const isEnum = (logLine, valueToDisplay) => {
    const value = log.oldValue.Value || log.newValue.Value;
    const isEnum = value && value.hasOwnProperty('Value') && value.hasOwnProperty('Name');

    if (!valueToDisplay || !valueToDisplay.Value) return '';

    return isEnum
      ? formatListValue({ id: valueToDisplay.Value.Value, list: valueToDisplay.Value.Name, intl })
      : valueToDisplay.Value;
  };

  const property = formatListValue({ list: 'Purpose', id: log.fieldId, intl, log });
  const medium = formatListValue({ list: 'Medium', id: log.oldValue.Medium, intl, log });

  if (log.oldValue.Value === null) {
    return (
      <span>
        {intl.formatMessage(messages.AddedCommunicationSetting, {
          property,
          medium,
          newValue: isEnum(log, log.newValue),
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  if (log.newValue.Value === null) {
    return (
      <span>
        {intl.formatMessage(messages.DeletedCommunicationSetting, {
          property,
          medium,
          oldValue: isEnum(log, log.oldValue),
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  return (
    <span>
      {intl.formatMessage(messages.ChangedCommunicationSetting, {
        property,
        medium,
        originalValue: isEnum(log, log.oldValue),
        currentValue: isEnum(log, log.newValue),
        b: value => <b>{value}</b>,
      })}
    </span>
  );
};

export default AddressSettingChange;
